export default function Hero() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50">
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Minimalist%20fashion%20product%20flatlay%20arrangement%20with%20white%20sneakers%2C%20folded%20hoodie%2C%20caps%2C%20and%20accessories%20on%20clean%20cream%20surface%2C%20soft%20natural%20lighting%2C%20aerial%20view%2C%20elegant%20composition%2C%20neutral%20warm%20tones%2C%20editorial%20product%20photography%20with%20subtle%20shadows%20and%20organic%20arrangement&width=1600&height=1200&seq=hero-texture-bg&orientation=landscape)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />

      <div className="relative z-10 w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-0">
          <div className="w-full lg:w-[40%] flex flex-col items-start text-left pt-10 lg:pt-0">
            <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl font-bold text-foreground-900 leading-[1.05]">
              YOYBUY<br />
              <span className="font-heading italic font-medium">Sheet</span>
            </h1>
            <p className="mt-6 text-base md:text-lg text-foreground-600 font-body leading-relaxed max-w-md">
              Инновационная spreadsheet-система для закупок из Китая. Экономьте до 60% на товарах с 1688, Taobao и других платформ через удобную таблицу заказов.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <span>YOYBUY SHEET</span>
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-background-50 border border-background-300 text-foreground-800 rounded-full text-sm font-medium hover:border-background-400 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <span>BUY IT NOW</span>
                <i className="ri-external-link-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          <div className="w-full lg:w-[60%] flex justify-end">
            <div className="w-full h-[380px] md:h-[520px] rounded-3xl overflow-hidden relative">
              <img
                src="https://readdy.ai/api/search-image?query=Fashion%20product%20collage%20with%20trendy%20sneakers%2C%20designer%20hoodie%2C%20baseball%20cap%2C%20leather%20bag%2C%20and%20minimalist%20accessories%20artistically%20arranged%20on%20warm%20cream%20backdrop%2C%20soft%20diffused%20natural%20light%2C%20editorial%20fashion%20photography%20style%2C%20clean%20aesthetic%2C%20elevated%20product%20presentation%20with%20organic%20textures%20and%20warm%20neutral%20palette&width=1200&height=900&seq=hero-collage-main&orientation=landscape"
                alt="YOYBUY Sheet товары"
                className="w-full h-full object-cover object-top"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}